const META_PIXEL_ID = process.env.GATSBY_META_PIXEL_ID || "980319157917128";
const ADMIN_PATH_PREFIX = "/admin";

const shouldTrackPath = (pathname = "") =>
  Boolean(META_PIXEL_ID) && !pathname.startsWith(ADMIN_PATH_PREFIX);

const loadMetaPixel = () => {
  if (typeof window === "undefined" || !shouldTrackPath(window.location.pathname)) {
    return;
  }

  if (window.fbq) {
    return;
  }

  void (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", META_PIXEL_ID);
};

exports.onClientEntry = () => {
  loadMetaPixel();
};

exports.onRouteUpdate = ({ location }) => {
  if (!shouldTrackPath(location.pathname)) {
    return;
  }

  loadMetaPixel();

  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView");
  }
};
